@if (showContainer) {
  <div class="location-active">
    @if (isLoading) {
      <div class="location-active__skeleton">
        <ngx-skeleton-loader
          appearance="line"
          [theme]="{ width: '110px', height: '32px', borderRadius: '16px' }"
        ></ngx-skeleton-loader>
      </div>
    } @else if (hasSelection && locationLabel) {
      <button
        type="button"
        class="location-active__tag inline-flex items-center gap-1 px-1 py-[5px] cursor-pointer"
        [matMenuTriggerFor]="locationMenu"
      >
        <mat-icon
          class="location-active__icon text-[10px] w-[10px] h-[10px] pl-[5.8px] pr-1"
          svgIcon="heroicons_solid:map-pin"
        ></mat-icon>
        <div class="location-active__label truncate pr-1">{{ locationLabel }}</div>
      </button>

      <mat-menu
        #locationMenu="matMenu"
        xPosition="after"
      >
        <button
          mat-menu-item
          class="location-menu-item flex items-center gap-[10px] pt-[8px] pb-[8px] pl-[18.09px] pr-[29.69px] text-text-default text-base"
          (click)="openChangeDialog()"
        >
          <mat-icon
            class="w-[12.8px] h-[12.8px] text-[12.8px] leading-none"
            svgIcon="heroicons_mini:arrows-right-left"
          ></mat-icon>
          <span class="text-text-default">{{ 'Alterar' | transloco }}</span>
        </button>

        <div class="w-full location-menu-divider">
          <div class="h-px w-full bg-[#D0D5DD]"></div>
        </div>

        <button
          mat-menu-item
          class="location-menu-item flex items-center gap-[10px] pt-[11.69px] pb-[7.69px] pl-[18.09px] pr-[29.69px] text-text-default text-base"
          (click)="removeSelection()"
        >
          <mat-icon
            class="w-[12.8px] h-[12.8px] text-[12.8px] leading-none"
            svgIcon="heroicons_solid:x-circle"
          ></mat-icon>
          <span class="text-text-default">{{ 'Remover' | transloco }}</span>
        </button>
      </mat-menu>
    }
  </div>
}
